import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/qrcodeIcon@2x.png'


const _hoisted_1 = {
  key: 0,
  class: "uf-approvalDetail"
}
const _hoisted_2 = { class: "uf-approvalDetail__header" }
const _hoisted_3 = { class: "uf-approvalDetail__header__bottom" }
const _hoisted_4 = { class: "uf-approvalDetail__process" }
const _hoisted_5 = { class: "uf-approvalDetail__process-date" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "uf-approvalDetail__process-i" }, [
  /*#__PURE__*/_createElementVNode("i"),
  /*#__PURE__*/_createElementVNode("b")
], -1)
const _hoisted_7 = { class: "uf-approvalDetail__process-value" }
const _hoisted_8 = { style: {"margin-right":"5px"} }
const _hoisted_9 = { style: {"color":"#3d6eeb","margin-right":"5px"} }
const _hoisted_10 = { style: {"font-weight":"bolder"} }
const _hoisted_11 = { style: {"color":"#2d333e"} }
const _hoisted_12 = { style: {"color":"#3d6eeb","margin-right":"5px"} }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bolder"} }, "退回了审批", -1)
const _hoisted_14 = { style: {"color":"#2d333e"} }
const _hoisted_15 = { class: "uf-approvalDetail__info" }
const _hoisted_16 = { class: "uf-approvalDetail__info__title" }
const _hoisted_17 = {
  class: "uf-approvalDetail__info__content",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { style: {"font-style":"normal"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"12px","height":"12px"},
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { style: {"font-style":"normal","font-size":"12px","margin-left":"5px"} }, "二维码", -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "text-theme" }
const _hoisted_22 = { class: "text-theme" }
const _hoisted_23 = { class: "uf-approvalDetail__info__footer" }
const _hoisted_24 = { style: {"color":"#3d6eeb"} }
const _hoisted_25 = { class: "uf-approvalDetail__info__footer" }
const _hoisted_26 = {
  key: 3,
  class: "uf-approvalDetail__info"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "uf-approvalDetail__info__content" }, "保单号", -1)
const _hoisted_28 = { class: "uf-approvalDetail__info__footer" }
const _hoisted_29 = { class: "uf-button" }
const _hoisted_30 = { class: "uf-button--footer" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "uf-footer-button__popover" }
const _hoisted_33 = { class: "uf-added" }
const _hoisted_34 = { class: "uf-added__item-name" }
const _hoisted_35 = { style: {"color":"#2c3746"} }
const _hoisted_36 = {
  key: 0,
  class: "uf-added__item-reason"
}
const _hoisted_37 = { class: "uf-added__item-date" }
const _hoisted_38 = { style: {"padding":"16px"} }
const _hoisted_39 = {
  key: 3,
  class: "qrcode-pop"
}
const _hoisted_40 = { class: "qrcode-content" }
const _hoisted_41 = ["src"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "qrcode-footer" }, "长按保存二维码", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_sub_form_item_group = _resolveComponent("sub-form-item-group")!
  const _component_uf_form = _resolveComponent("uf-form")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_popover = _resolveComponent("van-popover")!
  const _component_select_approve = _resolveComponent("select-approve")!
  const _component_choose_person = _resolveComponent("choose-person")!
  const _component_van_dialog = _resolveComponent("van-dialog")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_rules_regulations = _resolveComponent("rules-regulations")!
  const _component_van_empty = _resolveComponent("van-empty")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_van_cell, {
              class: "uf-approvalDetail__cell",
              border: false,
              title: `当前状态：${_ctx.state_name}`
            }, null, 8, ["title"]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_van_cell, {
                center: "",
                "is-link": "",
                to: {
            name: _ctx.$RouterName.PROCESS,
            params: {
              id: _ctx.id
            }
          }
              }, {
                title: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("i", null, _toDisplayString(_ctx.moment(_ctx.approval_process_on.create_time).format("HH:mm")), 1),
                      _createElementVNode("b", null, _toDisplayString(_ctx.moment(_ctx.approval_process_on.create_time).format("YY-MM-DD")), 1)
                    ]),
                    _hoisted_6,
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("i", _hoisted_8, _toDisplayString(_ctx.approval_process_on.user_info.from_name) + "-" + _toDisplayString(_ctx.approval_process_on.user_info.name), 1),
                      _createElementVNode("b", null, _toDisplayString(_ctx.approval_process_on.way_msg) + "，" + _toDisplayString(_ctx.approval_process_on.approval_state_name), 1)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          (_ctx.added_arr.length > 0)
            ? (_openBlock(), _createBlock(_component_van_cell, {
                key: 0,
                class: "uf-approvalDetail__border-bottom",
                center: "",
                "is-link": "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogShow = true))
              }, _createSlots({
                title: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.added_arr[0].from_name) + "-" + _toDisplayString(_ctx.added_arr[0].name), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.isPetitioner ? "回复" : "申请") + "加签", 1)
                  ])
                ]),
                _: 2
              }, [
                (_ctx.added_arr[0].reason)
                  ? {
                      name: "label",
                      fn: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, "原因描述：" + _toDisplayString(_ctx.added_arr[0].reason), 1)
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1024))
            : _createCommentVNode("", true),
          (_ctx.return_info.user_info.name)
            ? (_openBlock(), _createBlock(_component_van_cell, {
                key: 1,
                class: "uf-approvalDetail__border-bottom",
                center: ""
              }, {
                title: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.return_info.user_info.name), 1),
                    _hoisted_13
                  ])
                ]),
                label: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, "原因描述：" + _toDisplayString(_ctx.return_info.reason), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.pass_url)
            ? (_openBlock(), _createBlock(_component_van_cell, {
                key: 2,
                class: "uf-approvalDetail__border-bottom",
                title: "查看作业证",
                border: false,
                "is-link": "",
                onClick: _ctx.toPassUrl
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.name), 1),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", null, "审批编号：" + _toDisplayString(_ctx.code), 1),
              _createElementVNode("span", {
                style: {"width":"72px","height":"24px","margin-left":"12px","color":"rgb(255, 255, 255)","display":"flex","align-items":"center","justify-content":"center","border-radius":"4px","background":"#ffb62f"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.lookQrcode && _ctx.lookQrcode(...args)))
              }, _hoisted_20)
            ]),
            (_ctx.alarm_control_detail.id)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "uf-approvalDetail__info__content",
                  style: {"margin":"10px 0px 12px"},
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (
          _ctx.$router.push({
            name: _ctx.$RouterName.ALARM_DETAIL,
            query: { id: _ctx.alarm_control_detail.id }
          })
        ))
                }, [
                  _createTextVNode(" 关联报警： "),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.alarm_control_detail.alarm_code), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.event_detail.id)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "uf-approvalDetail__info__content",
                  style: {"margin":"10px 0px 12px"},
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (
          _ctx.$router.push({
            name: _ctx.$RouterName.EVENTS_DETAIL,
            params: { id: _ctx.event_detail.id }
          })
        ))
                }, [
                  _createTextVNode(" 关联事务： "),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.event_detail.event_code), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.user_con.department_name) + "- " + _toDisplayString(_ctx.user_con.name) + "-" + _toDisplayString(_ctx.user_con.mobile), 1)
            ]),
            _createElementVNode("div", _hoisted_25, "提交于 " + _toDisplayString(_ctx.create_date), 1)
          ]),
          (_ctx.insure_code)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.insure_code), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.insure_url)
            ? (_openBlock(), _createBlock(_component_van_cell, {
                key: 4,
                class: "uf-approvalDetail__bigCell",
                title: "电子保单",
                border: false,
                "is-link": "",
                onClick: _ctx.lookInsure
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (Number(_ctx.operating_conditions_json?.is_have))
            ? (_openBlock(), _createBlock(_component_van_cell, {
                key: 5,
                class: "uf-approvalDetail__bigCell",
                title: "查看规章制度",
                border: false,
                "is-link": "",
                onClick: _ctx.lookRules
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_uf_form, {
            "show-error": "",
            "scroll-to-error": "",
            "show-error-message": false
          }, {
            default: _withCtx(() => [
              (_ctx.approval_json.length > 0)
                ? (_openBlock(), _createBlock(_component_sub_form_item_group, {
                    key: 0,
                    list: _ctx.approval_json,
                    id: _ctx.approval_temp_id,
                    ref: "subFormItemGroupRef"
                  }, null, 8, ["list", "id"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opt_lists, (button, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: button.name
                }, [
                  (index < 2)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "uf-footer-button__content",
                        onClick: ($event: any) => (_ctx.buttonClick(button))
                      }, _toDisplayString(button.name), 9, _hoisted_31))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              (_ctx.buttonMoreList.length > 0)
                ? (_openBlock(), _createBlock(_component_van_popover, {
                    key: 0,
                    show: _ctx.showPopover,
                    "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showPopover) = $event)),
                    placement: "top-end",
                    actions: _ctx.buttonMoreList,
                    onSelect: _ctx.popoverSelect
                  }, {
                    reference: _withCtx(() => [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_van_icon, {
                          name: "ellipsis",
                          color: "#3d6eeb",
                          class: "uf-footer-button__more"
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["show", "actions", "onSelect"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_select_approve, {
      show: _ctx.selectApproveInfo.isShow,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectApproveInfo.isShow) = $event)),
      info: _ctx.selectApproveInfo.info,
      onSubmit: _ctx.selectApproveInfo.onSubmit
    }, null, 8, ["show", "info", "onSubmit"]),
    _createVNode(_component_choose_person, {
      show: _ctx.choosePerson.show,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.choosePerson.show) = $event)),
      multiple: "",
      onConfirm: _ctx.choosePerson.onConfirm
    }, null, 8, ["show", "onConfirm"]),
    _createVNode(_component_choose_person, {
      show: _ctx.choosePerson2.show,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.choosePerson2.show) = $event)),
      multiple: "",
      onConfirm: _ctx.choosePerson2.onConfirm
    }, null, 8, ["show", "onConfirm"]),
    _createVNode(_component_van_dialog, {
      show: _ctx.dialogShow,
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dialogShow) = $event)),
      title: `加签${_ctx.isPetitioner ? '回复' : '申请'}`,
      "close-on-click-overlay": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("ul", _hoisted_33, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.added_arr, (added, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "uf-added__item",
              key: index
            }, [
              _createElementVNode("div", _hoisted_34, [
                _createTextVNode(_toDisplayString(added.name) + " ", 1),
                _createElementVNode("span", _hoisted_35, _toDisplayString(added.msg), 1)
              ]),
              (added.reason)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(added.reason), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_37, _toDisplayString(added.create_date), 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["show", "title"]),
    _createVNode(_component_van_dialog, {
      show: _ctx.reasonDialog.show,
      "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.reasonDialog.show) = $event)),
      title: _ctx.reasonDialog.title,
      "show-cancel-button": "",
      "before-close": _ctx.reasonDialog.beforeClose,
      onConfirm: _ctx.reasonDialog.onConfirm
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_field, {
          modelValue: _ctx.reasonDialog.reason,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.reasonDialog.reason) = $event)),
          rows: "4",
          autosize: "",
          type: "textarea",
          placeholder: "请输入",
          "show-word-limit": ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["show", "title", "before-close", "onConfirm"]),
    _createVNode(_component_van_dialog, {
      show: _ctx.replyApplySign.show,
      "onUpdate:show": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.replyApplySign.show) = $event)),
      title: "处理加签",
      "show-cancel-button": "",
      onConfirm: _ctx.replyApplySign.onConfirm
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_van_radio_group, {
            modelValue: _ctx.replyApplySign.result,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.replyApplySign.result) = $event)),
            direction: "horizontal"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_radio, { name: "1" }, {
                default: _withCtx(() => [
                  _createTextVNode("同意")
                ]),
                _: 1
              }),
              _createVNode(_component_van_radio, { name: "2" }, {
                default: _withCtx(() => [
                  _createTextVNode("拒绝")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode(_component_van_field, {
          modelValue: _ctx.replyApplySign.reason,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.replyApplySign.reason) = $event)),
          rows: "4",
          autosize: "",
          type: "textarea",
          placeholder: "请输入",
          "show-word-limit": ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["show", "onConfirm"]),
    (_ctx.returnable_node.length > 0)
      ? (_openBlock(), _createBlock(_component_van_popup, {
          key: 1,
          show: _ctx.returnableNodePicker.show,
          "onUpdate:show": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.returnableNodePicker.show) = $event)),
          position: "bottom",
          "safe-area-inset-bottom": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_picker, {
              title: "选择节点",
              "columns-field-names": {
        text: 'name'
      },
              columns: _ctx.returnable_node,
              onConfirm: _ctx.returnableNodePicker.onConfirm,
              onCancel: _ctx.returnableNodePicker.onCancel
            }, null, 8, ["columns", "onConfirm", "onCancel"])
          ]),
          _: 1
        }, 8, ["show"]))
      : _createCommentVNode("", true),
    _createVNode(_component_rules_regulations, {
      show: _ctx.isShowrules.isRules,
      "onUpdate:show": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.isShowrules.isRules) = $event)),
      content: _ctx.operating_conditions_json?.content
    }, null, 8, ["show", "content"]),
    (_ctx.aboutQrcode.isQrcode)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "qrcodeMask",
          onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.closeQrcode && _ctx.closeQrcode(...args)))
        }))
      : _createCommentVNode("", true),
    (_ctx.aboutQrcode.isQrcode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("img", {
              src: _ctx.qrcode,
              alt: ""
            }, null, 8, _hoisted_41)
          ]),
          _hoisted_42
        ]))
      : _createCommentVNode("", true),
    (_ctx.showLock)
      ? (_openBlock(), _createBlock(_component_van_empty, {
          key: 4,
          class: "custom-image",
          image: require('@/assets/icon_lock.png'),
          description: "暂无查看权限"
        }, null, 8, ["image"]))
      : _createCommentVNode("", true)
  ], 64))
}